import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Media Library'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Media Library',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/media-library',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
